import { CSS_PROPERTY, getCssBasedOnRtl, media } from '../../../styles';

import styled from 'styled-components';

export const Label = styled.div`
  color: ${({ theme }) => theme.typography.color.primary};
  font-size: ${({ theme }) => theme.typography.size.medium};
  font-weight: ${({ theme }) => theme.typography.weight.bold};
  ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.MARGIN_LEFT, theme.spacing.base.xxs)};
`;

export const ToggleContainer = styled.div`
  height: 20px;
  width: 40px;

  ${media.mobilePortrait} {
    height: 24px;
    width: 48px;
  }
`;

export const Container = styled.div`
  display: inline-flex;
  height: 20px;
`;
